import { render, staticRenderFns } from "./dp-lock.vue?vue&type=template&id=27d454a6"
import script from "./dp-lock.vue?vue&type=script&lang=js"
export * from "./dp-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports